export default function HowItWorks() {
  const steps = [
    {
      num: "1",
      icon: "ri-map-pin-2-line",
      title: "Enter Your Zip Code",
      desc: "Tell us where you are and what tree service you need.",
    },
    {
      num: "2",
      icon: "ri-user-search-line",
      title: "Get Matched Instantly",
      desc: "We connect you with top-rated local tree pros in your area.",
    },
    {
      num: "3",
      icon: "ri-file-list-3-line",
      title: "Compare Free Quotes",
      desc: "Review estimates, read reviews, and pick the best pro for your job.",
    },
  ];

  return (
    <section className="bg-white border-b border-gray-100 py-10">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-0 divide-y md:divide-y-0 md:divide-x divide-gray-100">
          {steps.map((step) => (
            <div key={step.num} className="flex items-center gap-5 py-6 md:py-4 md:px-10 first:md:pl-0 last:md:pr-0">
              <div className="w-12 h-12 flex items-center justify-center bg-[#E8F5E9] rounded-full flex-shrink-0">
                <i className={`${step.icon} text-[#1B4332] text-xl`}></i>
              </div>
              <div>
                <p className="text-xs font-bold text-[#1B4332]/50 uppercase tracking-widest mb-0.5">Step {step.num}</p>
                <p className="font-bold text-[#1B4332] text-base">{step.title}</p>
                <p className="text-gray-500 text-sm mt-0.5">{step.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
